enum WatermarkDialogFields {
	MODE = 'mode',
	CONTENT = 'content',
	FONT_FAMILY = 'font_family',
	FONT_SIZE = 'font_size',
	FONT_COLOR = 'font_color',
	FONT_OPACITY = 'font_opacity',
	IMAGE_FILE = 'image',
	IMAGE_OPACITY = 'image_opacity',
	IMAGE_SCALE = 'image_scale',
	POSITION = 'position',
	MARGIN_LEFT = 'margin_left',
	MARGIN_TOP = 'margin_top',
	ASPECT_RATIO = 'aspect_ratio',
	ROTATION = 'rotation',
	PAGERANGE = 'pagerange',
	PREVIEW = 'preview'
}

export default WatermarkDialogFields;